(() => {
  function setup(gallery) {
    if (gallery.dataset.ready) return;
    const photos = [...gallery.querySelectorAll('[data-studio-photo]')];
    const choices = [...gallery.querySelectorAll('[data-studio-choice]')];
    if (!photos.length || !choices.length) return;
    gallery.dataset.ready = 'true';
    const description = gallery.querySelector('.camp-studio__description');
    const title = gallery.querySelector('[data-studio-title]');
    const copy = gallery.querySelector('[data-studio-copy]');
    const controls = gallery.querySelector('.camp-studio__choices');
    function select(value) {
      const selected = photos.find(photo => photo.dataset.studioPhoto === value);
      if (!selected) return;
      photos.forEach(photo => { photo.hidden = photo !== selected; });
      choices.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.studioChoice === value)));
      title.textContent = selected.querySelector('h3').textContent;
      copy.textContent = selected.querySelector('figcaption p').textContent;
    }
    select(choices[0].dataset.studioChoice);
    gallery.classList.add('camp-studio--ready');
    description.hidden = false;
    controls.hidden = false;
    choices.forEach(button => button.addEventListener('click', () => select(button.dataset.studioChoice)));
  }
  const boot = () => document.querySelectorAll('[data-studio-gallery]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
